import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { SiteAnnouncementList } from './SiteAnnouncementList/SiteAnnouncementList';
import { useCreateSiteAnnouncementSetupFlowPageModel, useEditSiteAnnouncementSetupFlowPageModel } from './SiteAnnouncementForm/SiteAnnouncementSetupFlowPageModel';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { ROUTE_PATH } from 'enum/RoutePath';
import { SiteAnnouncementSetupFlowPage } from './SiteAnnouncementForm/SiteAnnouncementSetupFlowPage';
import { SITE_ANNOUNCEMENT_LIST_PATH, SiteAnnouncementType } from 'core/siteAnnouncement/SiteAnnouncement';

export const SiteAnnouncements: React.FC = () => {

  // 兩個分類共用同一個列表 container，靠 prop 傳 type（不做一頁兩 tab，否則側欄的 active highlight 會錯）
  const renderSiteAnnouncementList = (type: SiteAnnouncementType) => (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(Permission.SITE_ANNOUNCEMENT_LIST_READ)}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <SiteAnnouncementList type={type} />
      </PermissionChecker>
    );
  };

  const redirectToNotFound = () => {
    return <Redirect to={{ pathname: `/site-announcements/${ROUTE_PATH.ERROR404}` }} />;
  };

  const renderCreateSiteAnnouncementForm = (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(Permission.SITE_ANNOUNCEMENT_WRITE)}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <SiteAnnouncementSetupFlowPage useModel={useCreateSiteAnnouncementSetupFlowPageModel} />
      </PermissionChecker>
    );
  };

  const renderEditSiteAnnouncementForm = (props: RouteComponentProps) => {
    return (
      <PermissionChecker
        permissionAware={hasFuncs(Permission.SITE_ANNOUNCEMENT_READ, Permission.SITE_ANNOUNCEMENT_WRITE)}
        redirectTo={`${props.match.url}/${ROUTE_PATH.ERROR403}`}
      >
        <SiteAnnouncementSetupFlowPage useModel={useEditSiteAnnouncementSetupFlowPageModel} />
      </PermissionChecker>
    );
  };

  return (
    <Switch>
      <Route
        path={'/site-announcements/new'}
        render={renderCreateSiteAnnouncementForm}
      />
      <Route
        path={'/site-announcements/:id/edit'}
        render={renderEditSiteAnnouncementForm}
      />
      {/* exact 不可省：沒有它會吃掉 /site-announcements 底下所有路徑 */}
      <Redirect
        exact
        from={'/site-announcements'}
        to={SITE_ANNOUNCEMENT_LIST_PATH[SiteAnnouncementType.SYSTEM]}
      />
      {/* exact 讓 /site-announcements/system/<垃圾> 落到下面的 404，而不是靜默顯示該分類列表 */}
      {/* key 讓兩個分類切換時整個列表重新掛載（否則 searchString / page 會被沿用） */}
      <Route
        exact
        key={SiteAnnouncementType.SYSTEM}
        path={SITE_ANNOUNCEMENT_LIST_PATH[SiteAnnouncementType.SYSTEM]}
        render={renderSiteAnnouncementList(SiteAnnouncementType.SYSTEM)}
      />
      <Route
        exact
        key={SiteAnnouncementType.PROMOTION}
        path={SITE_ANNOUNCEMENT_LIST_PATH[SiteAnnouncementType.PROMOTION]}
        render={renderSiteAnnouncementList(SiteAnnouncementType.PROMOTION)}
      />
      {/* 真正的 404：原本這裡是沒有 path 的 catch-all，任何打錯的子路徑都會靜默顯示系統公告列表 */}
      <Route
        render={redirectToNotFound}
      />
    </Switch>
  );
};
